import React from 'react';
import cls from './FileItem.module.css';
import { Icon } from 'shared/ui';

interface IFileItemActions {
    onClickHandler: (e: React.MouseEvent<HTMLDivElement>) => void;
    innerRef: React.MutableRefObject<HTMLSpanElement>;
}

export const FileItemActions = ({ onClickHandler, innerRef }: IFileItemActions) => {
    return (
        <span className={cls.fileItemActions} onClick={onClickHandler} ref={innerRef}>
            <Icon iconName={'moreActionsDots'} />
        </span>
    );
};
